import React, { useState, useRef } from "react";
import CourtAvailability from "./components/CourtAvailability";
import Watches from "./components/Watches";
import "./App.css";

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const courtRef = useRef(null);
  return (
    <div className="App">
      <CourtAvailability
        ref={courtRef}
        onWatchCreated={() => setRefreshKey((k) => k + 1)}
      />
      <Watches
        refreshKey={refreshKey}
        onEditWatch={(w) => courtRef.current && courtRef.current.loadWatchForEdit(w)}
      />
    </div>
  );
}

export default App;
